module.exports = __webpack_public_path__ + "static/img/nume__ro-5.dd73806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nume__ro-5.jpg
// module id = XC03
// module chunks = 0